// Header search live-suggestions dropdown: debounced AJAX fetch of matching
// `san-pham` products, rendered server-side (see inc/search.php).
const MIN_CHARS       = 2;
const DEBOUNCE_MS     = 300;
const AJAX_ACTION     = 'hgtheme_live_search';

const input       = document.getElementById('site-search');
const categorySel = document.getElementById('site-search-category');
const resultsEl   = document.getElementById('live-search-results');
const form        = input ? input.closest('form') : null;

let debounceTimer    = null;
let activeController = null;
let activeIndex      = -1;

function getSuggestionItems() {
	return resultsEl ? Array.from(resultsEl.querySelectorAll('.live-search__item')) : [];
}

function closeResults() {
	if (!resultsEl) {
		return;
	}
	resultsEl.hidden = true;
	resultsEl.innerHTML = '';
	activeIndex = -1;
	if (input) {
		input.setAttribute('aria-expanded', 'false');
	}
}

function openResults(html) {
	if (!resultsEl) {
		return;
	}
	resultsEl.innerHTML = html;
	resultsEl.hidden = false;
	activeIndex = -1;
	if (input) {
		input.setAttribute('aria-expanded', 'true');
	}
}

function highlightItem(index) {
	const items = getSuggestionItems();
	items.forEach((item, i) => {
		item.classList.toggle('is-active', i === index);
	});
	if (items[index]) {
		items[index].scrollIntoView({ block: 'nearest' });
	}
}

function fetchSuggestions(keyword) {
	if (activeController) {
		activeController.abort();
	}
	activeController = new AbortController();

	const params = new URLSearchParams({ action: AJAX_ACTION, s: keyword });
	if (categorySel && categorySel.value) {
		params.set('category', categorySel.value);
	}

	fetch(`${window.hgthemeData.ajaxUrl}?${params.toString()}`, {
		signal: activeController.signal,
	})
		.then((response) => response.text())
		.then((html) => openResults(html))
		.catch((error) => {
			if (error.name !== 'AbortError') {
				closeResults();
			}
		});
}

if (input && resultsEl) {
	input.addEventListener('input', () => {
		const keyword = input.value.trim();

		window.clearTimeout(debounceTimer);

		if (keyword.length < MIN_CHARS) {
			closeResults();
			return;
		}

		debounceTimer = window.setTimeout(() => fetchSuggestions(keyword), DEBOUNCE_MS);
	});

	if (categorySel) {
		categorySel.addEventListener('change', () => {
			const keyword = input.value.trim();
			if (keyword.length >= MIN_CHARS) {
				fetchSuggestions(keyword);
			}
		});
	}

	input.addEventListener('keydown', (e) => {
		const items = getSuggestionItems();

		if (e.key === 'ArrowDown' && items.length) {
			e.preventDefault();
			activeIndex = (activeIndex + 1) % items.length;
			highlightItem(activeIndex);
		} else if (e.key === 'ArrowUp' && items.length) {
			e.preventDefault();
			activeIndex = (activeIndex - 1 + items.length) % items.length;
			highlightItem(activeIndex);
		} else if (e.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) {
			e.preventDefault();
			const link = items[activeIndex].querySelector('a');
			if (link) {
				window.location.href = link.href;
			}
		} else if (e.key === 'Escape') {
			closeResults();
		}
	});

	document.addEventListener('click', (e) => {
		if (form && !form.contains(e.target)) {
			closeResults();
		}
	});
}
